import { Action } from '@ngrx/store';
import { ITravelHotelSubBooking } from '@shared/shared/interfaces/travel-hotel.interfaces';

export const VIEW_HOTEL_SUB_BOOKING = '[Hotel Sub Booking] View hotel sub booking';
export const VIEW_HOTEL_SUB_BOOKING_SUCCESS = '[Hotel Sub Booking] View hotel sub booking success';
export const VIEW_HOTEL_SUB_BOOKING_FAILURE = '[Hotel Sub Booking] View hotel sub booking failure';

export const CREATE_HOTEL_SUB_BOOKING = '[Hotel Sub Booking] Create hotel sub booking';
export const CREATE_HOTEL_SUB_BOOKING_SUCCESS = '[Hotel Sub Booking] Create hotel sub booking success';
export const CREATE_HOTEL_SUB_BOOKING_FAILURE = '[Hotel Sub Booking] Create hotel sub booking failure';

export const PATCH_HOTEL_SUB_BOOKING_TRAVELLERS = '[Hotel Sub Booking] Patch hotel sub booking travellers';
export const PATCH_HOTEL_SUB_BOOKING_TRAVELLERS_SUCCESS =
  '[Hotel Sub Booking] Patch hotel sub booking travellers success';
export const PATCH_HOTEL_SUB_BOOKING_TRAVELLERS_FAILURE =
  '[Hotel Sub Booking] Patch hotel sub booking travellers failure';

export const CLEAR_HOTEL_SUB_BOOKING = '[Hotel Sub Booking] Clear hotel sub booking';
export const CLEAR_HOTEL_TRAVELLER_PATCH = '[Travel Booking] Clear hotel traveller patch';

export class ClearHotelSubBooking implements Action {
  readonly type = CLEAR_HOTEL_SUB_BOOKING;
}

export class ViewHotelSubBooking implements Action {
  readonly type = VIEW_HOTEL_SUB_BOOKING;
}

export class ViewHotelSubBookingSuccess implements Action {
  readonly type = VIEW_HOTEL_SUB_BOOKING_SUCCESS;
  constructor(public payload: ITravelHotelSubBooking) {}
}

export class ViewHotelSubBookingFailure implements Action {
  readonly type = VIEW_HOTEL_SUB_BOOKING_FAILURE;
  constructor(public payload: any) {}
}

export class CreateHotelSubBooking implements Action {
  readonly type = CREATE_HOTEL_SUB_BOOKING;
}

export class CreateHotelSubBookingSuccess implements Action {
  readonly type = CREATE_HOTEL_SUB_BOOKING_SUCCESS;
  constructor(public payload: ITravelHotelSubBooking) {}
}

export class CreateHotelSubBookingFailure implements Action {
  readonly type = CREATE_HOTEL_SUB_BOOKING_FAILURE;
  constructor(public payload: any) {}
}

export class PatchHotelSubBookingTravellers implements Action {
  readonly type = PATCH_HOTEL_SUB_BOOKING_TRAVELLERS;
  constructor(public payload: any) {}
}

export class PatchHotelSubBookingTravellersSuccess implements Action {
  readonly type = PATCH_HOTEL_SUB_BOOKING_TRAVELLERS_SUCCESS;
  constructor(public payload: any) {}
}

export class PatchHotelSubBookingTravellersFailure implements Action {
  readonly type = PATCH_HOTEL_SUB_BOOKING_TRAVELLERS_FAILURE;
  constructor(public payload: any) {}
}

export class ClearHotelTravellerPatch implements Action {
  readonly type = CLEAR_HOTEL_TRAVELLER_PATCH;
}

export type TravelHotelSubBookingActions =
  | ClearHotelSubBooking
  | ViewHotelSubBooking
  | ViewHotelSubBookingSuccess
  | ViewHotelSubBookingFailure
  | CreateHotelSubBooking
  | CreateHotelSubBookingSuccess
  | CreateHotelSubBookingFailure
  | PatchHotelSubBookingTravellers
  | PatchHotelSubBookingTravellersSuccess
  | PatchHotelSubBookingTravellersFailure
  | ClearHotelTravellerPatch;
